export const replaceWith = (input, replacers) => {
	let result = []
	let lastIndex = 0
  
	replacers
	.flatMap((replacer, replacerIndex) => {
		const matches = Array.from(input.matchAll(replacer.rx))
		return matches.map((match, matchIndex) => ({
			match,
			replacerIndex,
			matchIndex,
			start: match.index,
			end: match.index + match[0].length,
		})
	)})
	.toSorted((a, b) => a.start - b.start)
	.forEach(({
		match,
		replacerIndex,
		matchIndex,
		start,
		end
	}) => {
	  const replacer = replacers[replacerIndex]
  
	  if (start > lastIndex) {
		result.push(input.slice(lastIndex, start))
	  }
  
	  result.push(replacer.fn(match, matchIndex))
	  lastIndex = end
	})
  
	if (lastIndex < input.length) {
	  result.push(input.slice(lastIndex))
	}
  
	return result
}


// WEBPACK FOOTER //
// ./src/components/utils/replace-with.js